import { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

export const authContext = createContext();

const AuthProvider = (props) => {
  const [role, setRole] = useState("");
  const [isAuth, setIsAuth] = useState(null);
  const [permissions, setPermissions] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token");

  useEffect(() => {

    if (!token) {
      setIsAuth(false);
      localStorage.clear();

      if (
        location.pathname !== "/login" &&
        location.pathname !== "/forgot-password"
      ) {
        navigate("/login", { replace: true });
      }
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "auth",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setRole(res?.data?.data?.role ?? "");
          setPermissions(
            Array.isArray(res?.data?.data?.permissions)
              ? res.data.data.permissions
              : [],
          );
          setIsAuth(true);
        } else {
          throw new Error("Unauthorized");
        }
      })
      .catch(() => {
        setIsAuth(false);
        localStorage.clear();

        if (location.pathname !== "/login") {
          navigate("/login", { replace: true });
        }
      });
  }, [token]);

  return (
    <authContext.Provider
      value={{ isAuth, setIsAuth, permissions, setPermissions, role, setRole }}
    >
      {props.children}
    </authContext.Provider>
  );
};
export default AuthProvider;
